import { Module } from 'vuex';
import { Nullable, RootState } from 'frontend/types';

export interface SponsorPbsNovaState {
  is_pbs_nova_traffic: boolean;
  percent_off: Nullable<string>;
}

const sponsorPbsNova: Module<SponsorPbsNovaState, RootState> = {
  namespaced: true,
  state: {
    is_pbs_nova_traffic: false,
  } as SponsorPbsNovaState,
  getters: {
    isPbsNovaTraffic: (state: SponsorPbsNovaState): boolean => state.is_pbs_nova_traffic,
    percentOff: (state: SponsorPbsNovaState): string | null => state.percent_off,
  },
  mutations: {
    setValue(state: SponsorPbsNovaState, value: SponsorPbsNovaState): void {
      Object.assign(state, value);
    },
  },
};

export default sponsorPbsNova;
